import React from 'react';
import { LayoutOrientations } from '../../globals';
import filterPropsEvents from '../reactUtils/filterPropsEvents';

interface IPanelProps
{
	children?: React.ReactNode;
	expand?: number | boolean | string;
	orientation?: LayoutOrientations;
	className?: string;
	"data-name"?: string;
	"data-status"?: string;
	style?: React.CSSProperties;
	tooltip?: string;
	onKeyDownCallback?: (e: React.KeyboardEvent) => void;
	size?: { x?: number | string, y?: number | string };
	[key: string]: any; // for any other props TODO: remove this and add specific props
}

const Panel = React.forwardRef<HTMLDivElement, IPanelProps>((props, ref) =>
{
	const expand = props.expand !== undefined ? props.expand ? "1" : "0" : "1";

	const styleOverrides = {};
	if (props.size?.y !== undefined)
	{
		styleOverrides["height"] = props.size.y;
		styleOverrides["minHeight"] = props.size.y;
		styleOverrides["maxHeight"] = props.size.y;
	}
	if (props.size?.x !== undefined)
	{
		styleOverrides["width"] = props.size.x;
		styleOverrides["minWidth"] = props.size.x;
		styleOverrides["maxWidth"] = props.size.x;
	}

	return (
		<div
			ref={ref}
			className={[
				"layoutPanel",
				(props.orientation ? props.orientation : LayoutOrientations.Vertical),
				(props.className ? props.className : ""),
			].join(' ')}
			data-name={props["data-name"]}
			data-status={props["data-status"]}
			style={{ flexGrow: expand, ...props.style,  ...styleOverrides }}
			tabIndex={props.onKeyDownCallback ? 0 : undefined}
			onKeyDown={(e)=>
			{
				if(props.onKeyDownCallback)
				{
					props.onKeyDownCallback(e);
				}
			}}
			{...filterPropsEvents(props)}
			data-tooltip={props["tooltip"] || props["data-tooltip"]}
		>
			{props.children}
		</div>
	)
});

export default Panel;